import React from 'react';
import classNames from 'classnames';
import { Label, FieldThumbnail } from '@tcc/crate';
import { Boundary } from '@tcc/shared-data-lib';
import { useAppSelector } from 'app/hooks';
import { getMessage } from 'util/locale';
import { buildUpgradeUrl } from 'util/urls';
import { parseBoundaryToGeoJson } from 'util/geometry';

type FieldNameProps = {
  name: string;
  canAdvancedScripting: boolean;
  boundary?: Boundary;
}

const baseString = 'field-name';
export const FieldName = ({ name, canAdvancedScripting, boundary }: FieldNameProps) => {
  const upgradePath = useAppSelector(buildUpgradeUrl);
  const classString = classNames({
    [`${baseString}`]: true,
    'needs-upgrade': !canAdvancedScripting
  });
  const geoJson = parseBoundaryToGeoJson(boundary);

  return (
    <div className={classString}>
      {geoJson && (<FieldThumbnail className={`${baseString}__thumbnail`} geoJson={geoJson} />)}
      <div title={name}>{name}</div>
      {!canAdvancedScripting && (
        <div
          className={`${baseString}__upgrade-link`}
          onClick={() => window.location.assign(upgradePath)} data-test-id='upgrade-plan-label'
        >
          <Label status='default' cornerType='circular' length='short' tone='light'>
            {getMessage('upgrade-plan-label')}
          </Label>
        </div>
      )}
    </div>
  );
};
